export type ToolId = 'fleetOptimisation' | 'postcodeStopAssignment';

export type ToolDefinition = {
  id: ToolId;
  title: string;
  description: string;
  ctaLabel: string;
  path: string;
  category: string;
  createdBy: string;
  isPublic: boolean;
};

export const TOOL_DEFINITIONS: ToolDefinition[] = [
  {
    id: 'fleetOptimisation',
    title: 'Fleet Cost & CO2 Optimiser',
    description:
      'Model annual operating cost and carbon outcomes before and after optimisation to quantify savings quickly.',
    ctaLabel: 'Calculate Savings',
    path: '/fleet-optimisation',
    category: 'financial',
    createdBy: 'CAB Agent',
    isPublic: false,
  },
  {
    id: 'postcodeStopAssignment',
    title: 'Postcode Stop/Hub Assignment',
    description:
      'Upload a postcode spreadsheet, geocode each row, query OpenStreetMap for nearby transit stops, assign the nearest stop, preview results, and download an enriched workbook.',
    ctaLabel: 'Assign Stops',
    path: '/tools/postcode-stop-assignment',
    category: 'routing',
    createdBy: 'CAB Agent',
    isPublic: false,
  },
];
